import { ConfigProvider, Flex, Loading } from '@/components';
import type { FC, PropsWithChildren } from 'react';

type Props = {
  isLoading: boolean;
  width: string;
  id?: string;
};

export const LedgerPage: FC<PropsWithChildren<Props>> = ({
  children,
  isLoading,
  width,
  id,
}) => {
  return (
    <ConfigProvider theme={{ token: { borderRadiusLG: 0 } }}>
      <Flex
        id={id}
        vertical
        style={{
          width,
          printColorAdjust: 'exact',
          WebkitPrintColorAdjust: 'exact',
        }}
      >
        {isLoading ? <Loading /> : children}
      </Flex>
    </ConfigProvider>
  );
};
